// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s_ajsZMxxuIeE6D8 {
	display: flex;
	align-items: center;
	gap: var(--lok-spacing-1);

	padding: var(--lok-spacing-1) var(--lok-spacing-2);
	border-radius: var(--lok-radius-tag);
	border: none;

	font: var(--lok-typography-body-tiny-strong);
	font-family: var(--lok-font-family-inter);
}

.vJad7YKMiogo2da2 {
	background-color: var(--lok-color-background-success);
	color: var(--lok-color-text-success);
}

.KUnuUPbb9Mkyndh0 {
	background-color: var(--lok-color-background-surface-fore);
	color: var(--lok-color-text-default);
}

.qlhqJNnf5uc7vPAs {
	background-color: var(--lok-color-background-surface-middle);
	color: var(--lok-color-text-light-default)
}

.LFzBWMI4JPIf8QDW {
	background-color: var(--lok-color-background-ai);
	color: var(--lok-color-text-ai);
}`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/ProjectTag/ProjectTag.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;;CAEzB,kDAAkD;CAClD,oCAAoC;CACpC,YAAY;;CAEZ,4CAA4C;CAC5C,yCAAyC;AAC1C;;AAEA;CACC,qDAAqD;CACrD,oCAAoC;AACrC;;AAEA;CACC,0DAA0D;CAC1D,oCAAoC;AACrC;;AAEA;CACC,4DAA4D;CAC5D;AACD;;AAEA;CACC,gDAAgD;CAChD,+BAA+B;AAChC","sourcesContent":[".base {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--lok-spacing-1);\n\n\tpadding: var(--lok-spacing-1) var(--lok-spacing-2);\n\tborder-radius: var(--lok-radius-tag);\n\tborder: none;\n\n\tfont: var(--lok-typography-body-tiny-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.active {\n\tbackground-color: var(--lok-color-background-success);\n\tcolor: var(--lok-color-text-success);\n}\n\n.inactive {\n\tbackground-color: var(--lok-color-background-surface-fore);\n\tcolor: var(--lok-color-text-default);\n}\n\n.default {\n\tbackground-color: var(--lok-color-background-surface-middle);\n\tcolor: var(--lok-color-text-light-default)\n}\n\n.custom {\n\tbackground-color: var(--lok-color-background-ai);\n\tcolor: var(--lok-color-text-ai);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `s_ajsZMxxuIeE6D8`,
	"active": `vJad7YKMiogo2da2`,
	"inactive": `KUnuUPbb9Mkyndh0`,
	"default": `qlhqJNnf5uc7vPAs`,
	"custom": `LFzBWMI4JPIf8QDW`
};
export default ___CSS_LOADER_EXPORT___;
